import { imageNames } from "@/src/constants/imageConstants.js";
import StatusTagProvider from "@/src/components/StatusTagProvider.vue";
import BehaviourTab from "@/src/components/voice_agents/voice_agent_tabs/BehaviourTab.vue";
import KnowledgeBaseTab from "@/src/components/voice_agents/voice_agent_tabs/KnowledgeBaseTab.vue";
import ActionsTab from "@/src/components/voice_agents/voice_agent_tabs/ActionsTab.vue";
import DataExtractionTab from "@/src/components/voice_agents/voice_agent_tabs/DataExtractionTab.vue";
import AdvancedSettingsTab from "@/src/components/voice_agents/voice_agent_tabs/AdvancedSettingsTab.vue";
import { commonDateOptions } from "@/src/constants/filterConstants.js";

export const agentSteps = [
  { id: "behaviour", label: "Behaviour", component: BehaviourTab },
  { id: "knowledge_base", label: "Knowledge Base", component: KnowledgeBaseTab },
  { id: "actions", label: "Actions", component: ActionsTab },
  { id: "data_extraction", label: "Data Extraction", component: DataExtractionTab },
  { id: "advanced_settings", label: "Advanced Settings", component: AdvancedSettingsTab },
];

export const languageMapping = {
  MULTILINGUAL: "multilingual",
  EN_US: "en-US",
  EN_IN: "en-IN",
  EN_GB: "en-GB",
  EN_AU: "en-AU",
  EN_NZ: "en-NZ",
  DE_DE: "de-DE",
  ES_ES: "es-ES",
  ES_419: "es-419",
  HI_IN: "hi-IN",
  FR_FR: "fr-FR",
  FR_CA: "fr-CA",
  JA_JP: "ja-JP",
  PT_PT: "pt-PT",
  PT_BR: "pt-BR",
  ZH_CN: "zh-CN",
  RU_RU: "ru-RU",
  IT_IT: "it-IT",
  KO_KR: "ko-KR",
  NL_NL: "nl-NL",
  NL_BE: "nl-BE",
  PL_PL: "pl-PL",
  TR_TR: "tr-TR",
  VI_VN: "vi-VN",
  RO_RO: "ro-RO",
  BG_BG: "bg-BG",
  CA_ES: "ca-ES",
  TH_TH: "th-TH",
  DA_DK: "da-DK",
  FI_FI: "fi-FI",
  EL_GR: "el-GR",
  HU_HU: "hu-HU",
  ID_ID: "id-ID",
  NO_NO: "no-NO",
  SK_SK: "sk-SK",
  SV_SE: "sv-SE",
  MS_MY: "ms-MY",
  AF_ZA: "af-ZA",
  AR_SA: "ar-SA",
  AZ_AZ: "az-AZ",
  BS_BA: "bs-BA",
  CY_GB: "cy-GB",
  FA_IR: "fa-IR",
  FIL_PH: "fil-PH",
  GL_ES: "gl-ES",
  HE_IL: "he-IL",
  HR_HR: "hr-HR",
  HY_AM: "hy-AM",
  IS_IS: "is-IS",
  KK_KZ: "kk-KZ",
  KN_IN: "kn-IN",
  MK_MK: "mk-MK",
  MR_IN: "mr-IN",
  NE_NP: "ne-NP",
  SL_SI: "sl-SI",
  SR_RS: "sr-RS",
  SW_KE: "sw-KE",
  TA_IN: "ta-IN",
  UR_IN: "ur-IN",
};

export const languageDetails = {
  [languageMapping.MULTILINGUAL]: {
    id: "multi",
    voice_id: "multi",
    name: "Multilingual",
    locale: "multi",
    useLocalFlag: true,
    flag: imageNames.FLAG_MULTILINGUAL,
  },
  [languageMapping.EN_US]: {
    id: "en-US",
    voice_id: "en-US",
    name: "English (United States)",
    locale: "en-US",
  },
  [languageMapping.EN_IN]: {
    id: "en-IN",
    voice_id: "en-IN",
    name: "English (India)",
    locale: "en-IN",
  },
  [languageMapping.EN_GB]: {
    id: "en-GB",
    voice_id: "en-GB",
    name: "English (United Kingdom)",
    locale: "en-GB",
  },
  [languageMapping.EN_AU]: {
    id: "en-AU",
    voice_id: "en-AU",
    name: "English (Australia)",
    locale: "en-AU",
  },
  [languageMapping.EN_NZ]: {
    id: "en-NZ",
    voice_id: "en-NZ",
    name: "English (New Zealand)",
    locale: "en-NZ",
  },
  [languageMapping.DE_DE]: {
    id: "de-DE",
    voice_id: "de-DE",
    name: "German (Germany)",
    locale: "de-DE",
  },
  [languageMapping.ES_ES]: {
    id: "es-ES",
    voice_id: "es-ES",
    name: "Spanish (Spain)",
    locale: "es-ES",
  },
  [languageMapping.ES_419]: {
    id: "es-419",
    voice_id: "es-419",
    name: "Spanish (Latin America)",
    locale: "es-419",
  },
  [languageMapping.HI_IN]: {
    id: "hi-IN",
    voice_id: "hi-IN",
    name: "Hindi (India)",
    locale: "hi-IN",
  },
  [languageMapping.FR_FR]: {
    id: "fr-FR",
    voice_id: "fr-FR",
    name: "French (France)",
    locale: "fr-FR",
  },
  [languageMapping.FR_CA]: {
    id: "fr-CA",
    voice_id: "fr-CA",
    name: "French (Canada)",
    locale: "fr-CA",
  },
  [languageMapping.JA_JP]: {
    id: "ja-JP",
    voice_id: "ja-JP",
    name: "Japanese",
    locale: "ja-JP",
  },
  [languageMapping.PT_PT]: {
    id: "pt-PT",
    voice_id: "pt-PT",
    name: "Portuguese (Portugal)",
    locale: "pt-PT",
  },
  [languageMapping.PT_BR]: {
    id: "pt-BR",
    voice_id: "pt-BR",
    name: "Portuguese (Brazil)",
    locale: "pt-BR",
  },
  [languageMapping.ZH_CN]: {
    id: "zh-CN",
    voice_id: "zh-CN",
    name: "Chinese (Simplified)",
    locale: "zh-CN",
  },
  [languageMapping.RU_RU]: {
    id: "ru-RU",
    voice_id: "ru-RU",
    name: "Russian",
    locale: "ru-RU",
  },
  [languageMapping.IT_IT]: {
    id: "it-IT",
    voice_id: "it-IT",
    name: "Italian",
    locale: "it-IT",
  },
  [languageMapping.KO_KR]: {
    id: "ko-KR",
    voice_id: "ko-KR",
    name: "Korean",
    locale: "ko-KR",
  },
  [languageMapping.NL_NL]: {
    id: "nl-NL",
    voice_id: "nl-NL",
    name: "Dutch (Netherlands)",
    locale: "nl-NL",
  },
  [languageMapping.NL_BE]: {
    id: "nl-BE",
    voice_id: "nl-BE",
    name: "Dutch (Belgium)",
    locale: "nl-BE",
  },
  [languageMapping.PL_PL]: {
    id: "pl-PL",
    voice_id: "pl-PL",
    name: "Polish",
    locale: "pl-PL",
  },
  [languageMapping.TR_TR]: {
    id: "tr-TR",
    voice_id: "tr-TR",
    name: "Turkish",
    locale: "tr-TR",
  },
  [languageMapping.VI_VN]: {
    id: "vi-VN",
    voice_id: "vi-VN",
    name: "Vietnamese",
    locale: "vi-VN",
  },
  [languageMapping.RO_RO]: {
    id: "ro-RO",
    voice_id: "ro-RO",
    name: "Romanian",
    locale: "ro-RO",
  },
  [languageMapping.BG_BG]: {
    id: "bg-BG",
    voice_id: "bg-BG",
    name: "Bulgarian",
    locale: "bg-BG",
  },
  [languageMapping.CA_ES]: {
    id: "ca-ES",
    voice_id: "ca-ES",
    name: "Catalan",
    locale: "ca-ES",
  },
  [languageMapping.TH_TH]: {
    id: "th-TH",
    voice_id: "th-TH",
    name: "Thai",
    locale: "th-TH",
  },
  [languageMapping.DA_DK]: {
    id: "da-DK",
    voice_id: "da-DK",
    name: "Danish",
    locale: "da-DK",
  },
  [languageMapping.FI_FI]: {
    id: "fi-FI",
    voice_id: "fi-FI",
    name: "Finnish",
    locale: "fi-FI",
  },
  [languageMapping.EL_GR]: {
    id: "el-GR",
    voice_id: "el-GR",
    name: "Greek",
    locale: "el-GR",
  },
  [languageMapping.HU_HU]: {
    id: "hu-HU",
    voice_id: "hu-HU",
    name: "Hungarian",
    locale: "hu-HU",
  },
  [languageMapping.ID_ID]: {
    id: "id-ID",
    voice_id: "id-ID",
    name: "Indonesian",
    locale: "id-ID",
  },
  [languageMapping.NO_NO]: {
    id: "no-NO",
    voice_id: "no-NO",
    name: "Norwegian",
    locale: "no-NO",
  },
  [languageMapping.SK_SK]: {
    id: "sk-SK",
    voice_id: "sk-SK",
    name: "Slovak",
    locale: "sk-SK",
  },
  [languageMapping.SV_SE]: {
    id: "sv-SE",
    voice_id: "sv-SE",
    name: "Swedish",
    locale: "sv-SE",
  },
  [languageMapping.MS_MY]: {
    id: "ms-MY",
    voice_id: "ms-MY",
    name: "Malay",
    locale: "ms-MY",
  },
  [languageMapping.AF_ZA]: {
    id: "af-ZA",
    voice_id: "af-ZA",
    name: "Afrikaans",
    locale: "af-ZA",
  },
  [languageMapping.AR_SA]: {
    id: "ar-SA",
    voice_id: "ar-SA",
    name: "Arabic",
    locale: "ar-SA",
  },
  [languageMapping.AZ_AZ]: {
    id: "az-AZ",
    voice_id: "az-AZ",
    name: "Azerbaijani",
    locale: "az-AZ",
  },
  [languageMapping.BS_BA]: {
    id: "bs-BA",
    voice_id: "bs-BA",
    name: "Bosnian",
    locale: "bs-BA",
  },
  [languageMapping.CY_GB]: {
    id: "cy-GB",
    voice_id: "cy-GB",
    name: "Welsh",
    locale: "cy-GB",
  },
  [languageMapping.FA_IR]: {
    id: "fa-IR",
    voice_id: "fa-IR",
    name: "Persian (Farsi)",
    locale: "fa-IR",
  },
  [languageMapping.FIL_PH]: {
    id: "fil-PH",
    voice_id: "fil-PH",
    name: "Filipino (Tagalog)",
    locale: "fil-PH",
  },
  [languageMapping.GL_ES]: {
    id: "gl-ES",
    voice_id: "gl-ES",
    name: "Galician",
    locale: "gl-ES",
  },
  [languageMapping.HE_IL]: {
    id: "he-IL",
    voice_id: "he-IL",
    name: "Hebrew",
    locale: "he-IL",
  },
  [languageMapping.HR_HR]: {
    id: "hr-HR",
    voice_id: "hr-HR",
    name: "Croatian",
    locale: "hr-HR",
  },
  [languageMapping.HY_AM]: {
    id: "hy-AM",
    voice_id: "hy-AM",
    name: "Armenian",
    locale: "hy-AM",
  },
  [languageMapping.IS_IS]: {
    id: "is-IS",
    voice_id: "is-IS",
    name: "Icelandic",
    locale: "is-IS",
  },
  [languageMapping.KK_KZ]: {
    id: "kk-KZ",
    voice_id: "kk-KZ",
    name: "Kazakh",
    locale: "kk-KZ",
  },
  [languageMapping.KN_IN]: {
    id: "kn-IN",
    voice_id: "kn-IN",
    name: "Kannada",
    locale: "kn-IN",
  },
  [languageMapping.MK_MK]: {
    id: "mk-MK",
    voice_id: "mk-MK",
    name: "Macedonian",
    locale: "mk-MK",
  },
  [languageMapping.MR_IN]: {
    id: "mr-IN",
    voice_id: "mr-IN",
    name: "Marathi",
    locale: "mr-IN",
  },
  [languageMapping.NE_NP]: {
    id: "ne-NP",
    voice_id: "ne-NP",
    name: "Nepali",
    locale: "ne-NP",
  },
  [languageMapping.SL_SI]: {
    id: "sl-SI",
    voice_id: "sl-SI",
    name: "Slovenian",
    locale: "sl-SI",
  },
  [languageMapping.SR_RS]: {
    id: "sr-RS",
    voice_id: "sr-RS",
    name: "Serbian",
    locale: "sr-RS",
  },
  [languageMapping.SW_KE]: {
    id: "sw-KE",
    voice_id: "sw-KE",
    name: "Swahili",
    locale: "sw-KE",
  },
  [languageMapping.TA_IN]: {
    id: "ta-IN",
    voice_id: "ta-IN",
    name: "Tamil",
    locale: "ta-IN",
  },
  [languageMapping.UR_IN]: {
    id: "ur-IN",
    voice_id: "ur-IN",
    name: "Urdu (India)",
    locale: "ur-IN",
  },
};

export const defaultLanguageId = languageMapping.EN_US;
export const defaultLanguage = languageDetails[defaultLanguageId];

export const voiceAgentActionTypes = {
  SCHEDULE_MEETING: "schedule_meeting",
  QUALIFICATION_AGENT: "qualification_agent",
};

export const transcriptRoles = {
  AGENT: "agent",
  USER: "user",
};

export const actionTypes = {
  SCHEDULE_MEETING: {
    type: voiceAgentActionTypes.SCHEDULE_MEETING,
    label: "Schedule Meeting",
    icon: imageNames.CALENDAR_TICK_GREY,
    description: "Enable your agent to book meetings and schedule appointments",
    fields: {
      actionName: {
        label: "Action Name",
        placeholder: "e.g., Book_Demo_Call",
      },
      meetingLink: {
        label: "Meeting Link",
        placeholder: "Select meeting link",
      },
      triggerPrompt: {
        label: "When should this action be triggered",
        placeholder: "Describe the caller request that should trigger this action (e.g., I'd like to book a demo with the Sales team)",
      },
      actionTimezone: {
        label: "Timezone Handling",
        placeholder: "Select timezone handling",
      },
    },
  },
  QUALIFICATION_AGENT: {
    type: voiceAgentActionTypes.QUALIFICATION_AGENT,
    label: "Qualification Agent",
    icon: imageNames.LIGHTNING,
    description: "Extract and qualify customer information during calls",
    fields: {
      actionName: {
        label: "Action Name",
        placeholder: "e.g., Extract_Customer_Budget",
      },
      qualificationCriteria: {
        label: "Define qualification criteria",
        placeholder: "Some criteria to be entered",
      },
    },
  },
};

export const timezoneHandlingTypes = {
  ASK_USER: "ask_user",
  FOLLOW_MEETING_AGENT: "follow_meeting_agent",
};

export const timezoneHandlingOptions = [
  { value: timezoneHandlingTypes.ASK_USER, label: "Ask user" },
  { value: timezoneHandlingTypes.FOLLOW_MEETING_AGENT, label: "Follow meeting agent timezone" },
];

export const actionMenuItems = [
  actionTypes.SCHEDULE_MEETING,
  actionTypes.QUALIFICATION_AGENT,
];

export const dataExtractionTypes = {
  TEXT: {
    type: "string",
    label: "Text",
    icon: imageNames.TEXT_EDITOR_GREY,
    description: "To extract textual information",
    fields: {
      name: {
        label: "Name",
        placeholder: "Enter name",
      },
      extraction: {
        label: "What should the agent extract from the call?",
        placeholder: 'e.g - "Summarize objections" or "List product features discussed"',
      },
    },
  },
  NUMBER: {
    type: "number",
    label: "Number",
    icon: imageNames.NUMBER_GREY,
    description: "To extract numbers from the conversation",
    fields: {
      name: {
        label: "Name",
        placeholder: "Enter name",
      },
      extraction: {
        label: "What should the agent extract from the call?",
        placeholder: 'e.g - "Extract the phone number" or "Order Id shared by the caller"',
      },
    },
  },
  BOOLEAN: {
    type: "boolean",
    label: "Boolean",
    icon: imageNames.BOOLEAN_GREY,
    description: "To extract answers to a yes or no question",
    fields: {
      name: {
        label: "Name",
        placeholder: "Enter name",
      },
      extraction: {
        label: "What should the agent extract from the call?",
        placeholder: 'e.g - "Was the appointment booked?" or "Is the caller statisfied"',
      },
    },
  },
};

export const dataExtractionMenuItems = [
  dataExtractionTypes.TEXT,
  dataExtractionTypes.NUMBER,
  dataExtractionTypes.BOOLEAN,
];

export const knowledgeBaseTypes = {
  TEXT: {
    type: "text",
    label: "Text",
    icon: imageNames.TEXT_EDITOR_GREY,
    description: "Add plain text content to your agent's knowledge base",
    fields: {
      name: {
        label: "Name",
        placeholder: "Enter name",
      },
      text: {
        label: "Add text based info as knowledge to your agent",
        placeholder: "Enter text",
      },
    },
  },
  LINK: {
    type: "link",
    label: "Link",
    icon: imageNames.LINK_ICON_GREY,
    description: "Add a webpage URL for your agent to reference",
    fields: {
      name: {
        label: "Name",
        placeholder: "Enter name",
      },
      url: {
        label: "URL",
        placeholder: "Enter URL",
      },
    },
  },
  FILE: {
    type: "file",
    label: "Upload File",
    icon: imageNames.UPLOAD_1_GREY,
    description: "Upload a document for your agent to use as knowledge",
    fields: {
      name: {
        label: "Name",
        placeholder: "Enter name",
      },
      file: {
        label: "Upload file",
        placeholder: "Upload file",
      },
    },
  },
};

export const knowledgeBaseMenuItems = [
  knowledgeBaseTypes.TEXT,
  knowledgeBaseTypes.LINK,
  knowledgeBaseTypes.FILE,
];

export const BehaviourFormFields = {
  ROLE_PERSONALITY: "role_personality",
  CALL_FLOW_INSTRUCTIONS: "call_flow_instructions",
};

export const BehaviourFormPlaceholders = {
  rolePersonality: "You are Mia, a support agent for SuperAGI, responsible for handling all customer interactions and booking appointments when necessary. Use a calm, supportive, and empathetic tone to make customers feel heard, understood, and taken care of.",
  callFlowInstructions: `1. Ask for the user's name to personalize the interaction.
2. Greet the user warmly, using their name, and introduce yourself as their voice assistant.
3. Inquire how they heard about us.
- < wait for user response >`,
};

export const tabHeaders = {
  behaviour: {
    title: "Agent Identity",
    description: "Add a background of the agent and describe the problem it will be solving",
  },
  knowledgeBase: {
    title: "Knowledge Base",
    description: "Add knowledge base to provide context to the agent.",
  },
  actions: {
    title: "Actions",
    description: "Enable your agent with capabilities such as calendar bookings, call termination, check availability, book a meeting, etc.",
  },
  dataExtraction: {
    title: "Data Extraction",
    description: "Tell the agent what to pull from each call and set the type for each item text number or boolean. We save the values as properties you can use in workflows and CRM.",
  },
  advancedSettings: {
    title: "Advanced Settings",
    description: "Fine-tune how your AI agent bahaves during calls for better control and smoother conversations",
  },
};

export const backgroundSoundOptions = [
  { value: "none", label: "None" },
  { value: "coffee-shop", label: "Coffee Shop" },
  { value: "convention-hall", label: "Convention Hall" },
  { value: "summer-outdoor", label: "Summer Outdoor" },
  { value: "mountain-outdoor", label: "Mountain Outdoor" },
  { value: "static-noise", label: "Static Noise" },
  { value: "call-center", label: "Call Center" },
];

export const denoisingModes = {
  NOISE_CANCELLATION: "noise-cancellation",
  NOISE_AND_BACKGROUND_SPEECH_CANCELLATION: "noise-and-background-speech-cancellation",
};

export const advancedSettingsFieldMapping = {
  background_sound: "background_sound",
  smart_noise_cancellation: "denoising_mode",
  responsiveness: "responsiveness",
  interruption_sensitivity: "interruption_sensitivity",
  maximum_call_duration: "max_call_duration_ms",
  end_call_on_silence: "end_call_after_silence_ms",
  pause_before_speaking: "begin_message_delay_ms",
  follow_up_times: "reminder_max_count",
  follow_up_interval: "reminder_trigger_ms",
};

export const advancedSettingsDefaults = {
  responsiveness: 1.0,
  interruptionSensitivity: 1.0,
  maximumCallDuration: 15,
  endCallOnSilence: 120,
  pauseBeforeSpeaking: 0,
  followUpTimes: 5,
  followUpInterval: 10,
};

export const advancedSettingsConfig = {
  responsiveness: {
    label: "Responsiveness",
    min: 0,
    max: 1,
    step: 0.01,
    minLabel: "Low",
    maxLabel: "High",
    default: 1.0,
  },
  interruptionSensitivity: {
    label: "Interruption Sensitivity",
    min: 0,
    max: 1,
    step: 0.01,
    minLabel: "Low",
    maxLabel: "High",
    default: 1.0,
  },
  agentFollowUp: {
    description: "Blocks out background noise from the caller to improve accuracy. Best used in loud environments. May reduce recognition of soft-spoken callers or echo.",
    defaultTimes: 5,
    defaultInterval: 10,
  },
  maximumCallDuration: {
    label: "Maximum Call Duration",
    min: 1,
    max: 120,
    step: 1,
    minLabel: "1min",
    maxLabel: "2hrs",
    default: 15,
    unit: "mins",
  },
  endCallOnSilence: {
    label: "End Call on Silence",
    min: 10,
    max: 1800,
    step: 1,
    minLabel: "10sec",
    maxLabel: "30mins",
    default: 120,
    unit: "secs",
  },
  pauseBeforeSpeaking: {
    label: "Pause before speaking",
    min: 0,
    max: 5,
    step: 0.1,
    minLabel: "0sec",
    maxLabel: "5secs",
    default: 0,
    unit: "secs",
  },
};

export const voiceAgentTableHeaders = [
  {
    label: "Agent Name",
    dataIndex: "name",
    key: "name",
    width: 2,
  },
  // {
  //   label: "Agent actions",
  //   dataIndex: "agent_actions",
  //   key: "agent_actions",
  //   width: 2,
  // },

  {
    label: "Voice",
    dataIndex: "voice_name",
    key: "voice_name",
    width: 2,
    avatar: "profile_pic",
  },
  {
    label: "Status",
    dataIndex: "status",
    key: "status",
    width: 2,
  },
  {
    label: "Created At",
    dataIndex: "created_at_formatted",
    key: "created_at_formatted",
    width: 2,
  },
  {
    label: "Created By",
    dataIndex: "created_by_name",
    key: "created_by_name",
    width: 2,
    view: true,
  },
  {
    label: "Updated By",
    dataIndex: "updated_by_name",
    key: "updated_by_name",
    width: 2,
    view: true,
  },
];

export const voiceAgentFiltersOptions = [
  {
    id: "voice",
    name: "Voice",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "status",
    name: "Status",
    type: "select",
    options: [
      { id: "active", name: "Active" },
      { id: "inactive", name: "Inactive" },
    ],
    searchable: false,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "created_date",
    name: "Created At",
    options: commonDateOptions,
    searchable: false,
    multiSelect: false,
    showInitials: false,
  },
  {
    id: "created_by",
    name: "Created By",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: true,
  },
];

export const deleteAgentModal = {
  title: "Delete Agent?",
  message: "Are you sure you want to delete this voice agent?",
  note: "Note: Deleting this agent removes it from all active campaigns. Any campaign that uses it will stop.",
};

export const voiceAgentCustomColumnRenderConfig = {
  status: StatusTagProvider,
};

export const campaignTableHeaders = [
  {
    label: "Name",
    dataIndex: "name",
    key: "name",
    width: 2,
  },
  {
    label: "Status",
    dataIndex: "status",
    key: "status",
    width: 2,
  },
  {
    label: "Voice Agent",
    dataIndex: "agent_name",
    key: "agent_name",
    width: 2,
  },
  {
    label: "Total Contacts",
    dataIndex: "total_contacts",
    key: "total_contacts",
    width: 2,
  },
  {
    label: "Answered",
    dataIndex: "answered",
    key: "answered",
    width: 2,
  },
  {
    label: "Skipped",
    dataIndex: "skipped",
    key: "skipped",
    width: 2,
  },
  {
    label: "Created At",
    dataIndex: "created_at_formatted",
    key: "created_at_formatted",
    width: 2,
  },
  {
    label: "Created By",
    dataIndex: "created_by_name",
    key: "created_by_name",
    width: 2,
    view: true,
  },
];

export const campaignFiltersOptions = [
  {
    id: "status",
    name: "Status",
    type: "select",
    options: [
      { id: "draft", name: "Draft" },
      { id: "active", name: "Active" },
      { id: "paused", name: "Paused" },
      { id: "completed", name: "Completed" },
      { id: "ended", name: "Ended" },
      { id: "hungup", name: "Hungup" },
    ],

    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "agent_id",
    name: "Voice Agent",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "created_date",
    name: "Created At",
   
    options: commonDateOptions,
    searchable: false,
    multiSelect: false,
    showInitials: false,
  },
  {
    id: "created_by",
    name: "Created By",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: true,
  },
];

export const defaultVoiceId = "11labs-Mia";

export const defaultVoice = {
  voice_id: "11labs-Mia",
  voice_name: "Mia",
  provider: "elevenlabs",
  accent: "American",
  gender: "female",
  age: "Middle Aged",
  avatar_url: "https://retell-utils-public.s3.us-west-2.amazonaws.com/mia.png",
  preview_audio_url: "https://retell-utils-public.s3.us-west-2.amazonaws.com/Mia.mp3",
};

export const deleteCampaignModal = {
  title: "Delete Campaign?",
  message: "Are you sure you want to delete this voice agent campaign?",
  note: "Note: Deleting this campaign will permanently remove all campaign data and cannot be undone.",
};

export const campaignCustomColumnRenderConfig = {
  status: StatusTagProvider,
};

export const DIRECTION_TYPES = {
  INBOUND: "inbound",
  OUTBOUND: "outbound",
};

export const callLogsTableHeaders = [
  {
    label: "Contact/Lead Number",
    dataIndex: "contact_number",
    key: "contact_number",
    width: 2,
  },
  {
    label: "Contact/Lead",
    dataIndex: "entity_name",
    key: "entity_name",
    width: 2,
    view: true,
  },
  {
    label: "Your Number",
    dataIndex: "your_number",
    key: "your_number",
    width: 2,
  },
  {
    label: "Voice Agent Name",
    dataIndex: "voice_agent_name",
    key: "voice_agent_name",
    width: 2,
  },
  {
    label: "Direction",
    dataIndex: "direction",
    key: "direction",
    width: 2,
  },
  {
    label: "Date and Time",
    dataIndex: "created_at_formatted",
    key: "created_at_formatted",
    width: 2,
  },
  {
    label: "Status",
    dataIndex: "status",
    key: "status",
    width: 2,
  },
  {
    label: "Duration",
    dataIndex: "duration_formatted",
    key: "duration_formatted",
    width: 2,
  },
  {
    label: "Campaign Name",
    dataIndex: "campaign_name",
    key: "campaign_name",
    width: 2,
  },
];

export const callLogsCustomColumnRenderConfig = {
  status: StatusTagProvider,
};

export const callLogDetailTabs = [
  { title: "Recording & Transcript"},
  { title: "Call Intelligence" },
  { title: "Data Extraction" },
  { title: "Agent Actions" },
  { title: "Notes" }, 
];

export const callLogDetailRightTabs = [
  { title: "Associations" },
  { title: "Comments" },
];

export const commentsPaginationConfig = {
  PAGE_SIZE: 10,
  INITIAL_PAGE: 1,
};

export const callAnalysisTypes = {
  CALL_INTELLIGENCE: "call_intelligence",
  DATA_EXTRACTION: "data_extraction",
  AGENT_ACTIONS: "agent_actions",
};

export const callAnalysisTitles = {
  [callAnalysisTypes.CALL_INTELLIGENCE]: "Call Intelligence",
  [callAnalysisTypes.DATA_EXTRACTION]: "Data Extraction",
  [callAnalysisTypes.AGENT_ACTIONS]: "Agent Actions",
};

export const callIntelligenceFields = [
  {
    key: "user_sentiment",
    label: "User Sentiment",
    type: "text",
  },
  {
    key: "call_summary",
    label: "Call Summary",
    type: "text",
  },
];

export const callAnalysisDataKeys = {
  CALL_INTELLIGENCE: ["user_sentiment", "call_summary"],
  DATA_EXTRACTION: "data_extracted",
  AGENT_ACTIONS: "post_call_analysis_data",
};

export const callLogsFiltersOptions = [
  {
    id: "phone_number",
    name: "Phone Number",
    type: "select",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "agent_id",
    name: "Voice Agent",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "campaign_id",
    name: "Campaign",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
    searchOptions: async (query) => {
      const { fetchCampaigns } = await import("@/src/utils/callsUtils.js");
      const { dialerTypes } = await import("@/src/constants/callConstants.js");
      const res = await fetchCampaigns(
        { page: 1, pageSize: 50, searchQuery: query || "", filters: [] },
        dialerTypes.VOICE_AGENTS_DIALER,
      );
      return (res?.campaigns || []).map((c) => ({
        id: c.id,
        name: c.name || `Campaign ${c.id}`,
      }));
    },
  },
  {
    id: "status",
    name: "Status",
    type: "select",
    options: [
      { id: "completed", name: "Completed" },
      { id: "failed", name: "Failed" },
      { id: "busy", name: "Busy" },
      { id: "no-answer", name: "No Answer" },
      { id: "cancelled", name: "Cancelled" },
    ],
    searchable: false,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "user_id",
    name: "User",
    type: "user",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: true,
  },
  {
    id: "created_date",
    name: "Created At",
    options: commonDateOptions,
    searchable: false,
    multiSelect: false,
    showInitials: false,
  },
];

export const dynamicVariableTableHeaders = [
  {
    label: "Variable Name",
    dataIndex: "variable_name",
    key: "variable_name",
    width: 1,
  },
  {
    label: "Fallback Value",
    dataIndex: "variable_fallback_value",
    key: "variable_fallback_value",
    width: 1,
  },
];

export const entityFieldOptions = [
  { label: "First Name", value: "first_name", key: "first_name" },
  { label: "Last Name", value: "last_name", key: "last_name" },
  { label: "Email", value: "email", key: "email" },
  { label: "Phone Number", value: "phone_number", key: "phone_number" },
  { label: "Company", value: "current_company", key: "current_company" },
  { label: "Current Role", value: "current_role", key: "current_role" },
  { label: "City", value: "city", key: "city" },
  { label: "State", value: "state", key: "state" },
  { label: "Country", value: "country", key: "country" },
  { label: "Timezone", value: "timezone", key: "timezone" },
  { label: "LinkedIn URL", value: "linkedin_url", key: "linkedin_url" },
];

